import { useState } from 'react'

const navBtn = { width:28, height:28, borderRadius:'50%', border:'1px solid #E5E0D8', background:'#fff', cursor:'pointer', fontSize:'1rem', color:'#6B6B6B', lineHeight:1 }

/**
 * Month calendar of a vendor's availability.
 *  - blocked: Set of 'YYYY-MM-DD' the vendor is unavailable.
 *  - onToggle(dStr): if provided, the calendar is interactive (vendor side).
 *    If omitted, it's read-only (couple side).
 *  - highlight: a 'YYYY-MM-DD' to ring (e.g. the couple's wedding date).
 */
export default function AvailabilityCalendar({ blocked, onToggle, highlight }) {
  const [calMonth, setCalMonth] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1) })
  const interactive = typeof onToggle === 'function'

  const year = calMonth.getFullYear(), month = calMonth.getMonth()
  const firstDow = new Date(year, month, 1).getDay()
  const daysInMonth = new Date(year, month + 1, 0).getDate()
  const cells = [...Array(firstDow).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)]
  const today = new Date(); today.setHours(0, 0, 0, 0)
  const pad = n => String(n).padStart(2, '0')
  const dStrOf = d => `${year}-${pad(month + 1)}-${pad(d)}`
  const monthLabel = calMonth.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'0.75rem' }}>
        <button onClick={()=>setCalMonth(new Date(year, month-1, 1))} style={navBtn}>‹</button>
        <span style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.82rem', fontWeight:700 }}>{monthLabel}</span>
        <button onClick={()=>setCalMonth(new Date(year, month+1, 1))} style={navBtn}>›</button>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:4 }}>
        {['S','M','T','W','T','F','S'].map((d,i) => <div key={i} style={{ textAlign:'center', fontFamily:'Nunito Sans, sans-serif', fontSize:'0.62rem', color:'#BCBCBC', fontWeight:700, padding:'0.25rem 0' }}>{d}</div>)}
        {cells.map((d, i) => {
          if (!d) return <div key={`e${i}`} />
          const dStr = dStrOf(d)
          const past = new Date(year, month, d) < today
          const isBlocked = blocked?.has(dStr)
          const isHi = highlight === dStr
          return (
            <button key={dStr} onClick={()=> interactive && !past && onToggle(dStr)} disabled={!interactive || past}
              title={isHi ? 'Your wedding date' : undefined}
              style={{ aspectRatio:'1', borderRadius:'0.5rem',
                border: isHi ? '2px solid #9BAF9B' : '1px solid #F0EDE7',
                cursor: (interactive && !past) ? 'pointer' : 'default',
                fontFamily:'Nunito Sans, sans-serif', fontSize:'0.8rem', fontWeight: (isBlocked || isHi) ? 700 : 500,
                color: past ? '#D1C9C0' : isBlocked ? '#fff' : '#1A1A1A',
                background: isBlocked ? '#C4826A' : past ? '#FAFAF8' : '#fff' }}>
              {d}
            </button>
          )
        })}
      </div>
      <div style={{ display:'flex', gap:'1rem', marginTop:'0.75rem', fontFamily:'Nunito Sans, sans-serif', fontSize:'0.68rem', color:'#9B9B9B' }}>
        <span style={{ display:'inline-flex', alignItems:'center', gap:'0.3rem' }}><span style={{ width:10, height:10, borderRadius:3, background:'#C4826A', display:'inline-block' }}/> Booked</span>
        {highlight && <span style={{ display:'inline-flex', alignItems:'center', gap:'0.3rem' }}><span style={{ width:10, height:10, borderRadius:3, border:'2px solid #9BAF9B', display:'inline-block' }}/> Your date</span>}
      </div>
    </div>
  )
}
